import { useOnlineStatus } from '../hooks/useOnlineStatus';
import {useEffect,useState} from 'react';

export function ConnectivityBanner() {
  const isOnline = useOnlineStatus();
  const [shellFault,setShellFault]=useState('');
  useEffect(()=>{const error=()=>setShellFault('Offline app shell is not ready. Connect and recover device storage before relying on offline reload.');const state=event=>event.detail?.ready?setShellFault(''):error();window.addEventListener('workbill:shell-error',error);window.addEventListener('workbill:shell-readiness',state);return()=>{window.removeEventListener('workbill:shell-error',error);window.removeEventListener('workbill:shell-readiness',state);};},[]);
  if(isOnline&&!shellFault)return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="connectivity-banner"
    >
      {shellFault||'Offline - bills are provisional until server confirmation. Saved price, policy and stock may need review.'}
    </div>
  );
}
